import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { EditionListService } from './edition.service';
import { Edition } from '../models/global/edition';

@Component({
  selector: 'app-editions',
  templateUrl: './editions.component.html',
  styleUrls: ['./editions.component.less']
})
export class EditionsComponent implements OnInit {
  public editions: Edition[] = null;
  public recentEditions: Edition[] = null;
  private editionName: string;

  constructor(private api: EditionListService, private router: Router) {
    this.api.getEditions(true).subscribe(editions => {
      this.editions = editions;
      this.recentEditions = this.editions
        .filter(e => e.recent !== null)
        .sort((a, b) => a.recent - b.recent);
    });
    this.api.waitForEdition().subscribe(edition => this.editionName = edition.name);
  }

  ngOnInit() {
  }

  private chooseEdition(edition: Edition) {
    this.api.setCurrentEdition(edition);
    this.router.navigate(['dashboard']);
    return false;
  }

  private editionSettings(edition: Edition) {
    this.api.setCurrentEdition(edition);
    this.router.navigate(['global-settings']);
    return false;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/editions/editions.component.ts